export default __webpack_public_path__ + "23aace24d91cea85d2359c5a11dd2a3a.svg";